import useModalHook from '@/hooks/useModalHook';
import type { ModalPosition } from '@/stores/modalStore';

export const useErrorHandler = () => {
  const { openModal, closeModal } = useModalHook();

  const showServerError = (pos: ModalPosition = 'default') => {
    openModal(
      {
        type: 'errorModal',
        props: {
          onCancel() {
            closeModal('errorModal', pos);
          },
          onConfirm() {
            closeModal('errorModal', pos);
          },
        },
      },
      pos,
    );
  };

  const openErrorAlert = ({
    depth,
    message,
    onConfirm,
  }: {
    depth?: number;
    message?: string;
    onConfirm?: () => void;
  }) => {
    openModal({
      type: 'errorModal',
      props: {
        message: message,
        depth: depth,
        onCancel() {
          closeModal('errorModal');
        },
        onConfirm() {
          onConfirm ? onConfirm() : closeModal('errorModal');
        },
      },
    });
  };

  return { showServerError, openErrorAlert };
};
